import React, { useState } from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';

const FooterContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 78px;
  padding: 14px 29px;
  border-top: 1px solid var(--line-gray);
`;

const FooterRight = styled.div`
  display: flex;
  gap: 10px;
`;

const StyledButton = styled(Button)`
  min-width: 104px;
  height: 40px;
  padding: 0 24px;
`;

const DeleteButton = styled(StyledButton)`
  &&& {
    background-color: var(--light-orange);
    border: solid 1px var(--negative-orange);
    color: var(--negative-orange);
    min-width: 136px;
  }
`;

interface Props {
  isEditing: boolean;
  isSaving: boolean;
  onCancel: () => void;
  onDelete?: () => void;
  onSubmit: () => void | Promise<void>;
}

const CreateEditActionPlansModalFooter = ({ isEditing, isSaving, onCancel, onDelete, onSubmit }: Props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSaveDisabled = isSaving || isSubmitting;

  const handleSubmit = async () => {
    if (isSaveDisabled) {
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FooterContainer>
      <div>
        {isEditing && onDelete && (
          <DeleteButton htmlType="button" disabled={isSaveDisabled} onClick={onDelete}>
            Delete Plan
          </DeleteButton>
        )}
      </div>
      <FooterRight>
        <StyledButton
          htmlType="button"
          type="primary"
          loading={isSaveDisabled}
          disabled={isSaveDisabled}
          onClick={handleSubmit}
        >
          Save
        </StyledButton>
        <StyledButton htmlType="button" disabled={isSaveDisabled} onClick={onCancel}>
          Cancel
        </StyledButton>
      </FooterRight>
    </FooterContainer>
  );
};

export default CreateEditActionPlansModalFooter;
